import { HeartOutlined } from "@ant-design/icons"
import { Button } from "antd"
import React, { useEffect } from "react"
import { Link } from "react-router-dom"
import { useRecoilValue } from "recoil"
import styled from "styled-components"

import { Spin } from "../../components/atoms/Spin"
import { Detail, DetailTitle } from "../../components/atoms/detail"
import JobseekerList from "../../components/jobseeker/jobseekerList"
import { useJobseeker } from "../../hooks"
import { useInitializeAccountData } from "../../hooks/useInitializeAccountData"
import { useAsyncLoading } from "../../hooks/useLoading"
import { jobseekerState } from "../../recoils"
import { companyState } from "../../recoils/companyState"
import {
  isClientNotFoundState,
  isCompanyNotFoundState,
} from "../../recoils/isNotFoundState"
import { NotFoundPage } from "../error/404"

import type { Jobseeker } from "../../interfaces/IJobseeker"

const dummyJobseekers: Jobseeker[] = []
for (let i = 0; i < 20; i++) {
  dummyJobseekers.push({
    id: "sample" + i,
    recruitId: "sample",
    desiredShip: "船の種類",
    desiredSalary: "希望月収",
    desiredPrefecture: "希望勤務地",
    licenses: ["取得免状1", "取得免状2"],
    isInterested: true,
  })
}

export const JobseekerPage = (): JSX.Element => {
  const [loading, asyncLoading] = useAsyncLoading("jobseekerIndex")
  const company = useRecoilValue(companyState)
  const jobseekers = useRecoilValue(jobseekerState)
  const isClientNotFound = useRecoilValue(isClientNotFoundState)
  const isCompanyNotFound = useRecoilValue(isCompanyNotFoundState)
  const initialize = useInitializeAccountData()
  const { fetchJobseekers } = useJobseeker()

  const fetchData = async () => {
    await Promise.all([initialize(), fetchJobseekers()])
  }

  useEffect(() => {
    asyncLoading(fetchData())
  }, [company])

  if (isClientNotFound || isCompanyNotFound) {
    return <NotFoundPage />
  }

  return (
    <Detail>
      <DetailTitle>応募者一覧</DetailTitle>
      <Description>
        <Link to="/plan">有料プラン</Link>
        に加入することで、応募者一覧を確認できます。
        <br />
        気になる応募者には
        <StyledButton danger shape="circle" icon={<HeartOutlined />} />
        を押すことで、応募者にアピールすることができます。
      </Description>
      {loading ? <Spin /> : <JobseekerList jobseekers={jobseekers} />}
    </Detail>
  )
}

const Description = styled.div`
  margin: 20px 0;
`

const StyledButton = styled(Button)`
  cursor: not-allowed;
  margin: 0 10px;
`
